// Copia um texto para a área de transferência.
//
// O caminho principal é a Clipboard API. O fallback com textarea +
// execCommand existe porque a Clipboard API só está disponível em contexto
// seguro (HTTPS ou localhost) — numa instalação servida por HTTP puro ela
// simplesmente não existe, e sem o fallback a cópia falharia em silêncio.
//
// O retorno ao usuário é um snackbar, para que todo lugar do sistema avise da
// mesma forma. `setSnackbar` é opcional: sem ele a cópia acontece do mesmo
// jeito, apenas sem aviso.
async function copyTexto({ campo, setSnackbar, mensagem = "Campo copiado!" }) {
  if (campo === null || campo === undefined || campo === "") return false;

  const texto = String(campo);
  let copiou = true;

  try {
    await navigator.clipboard.writeText(texto);
  } catch (err) {
    const textArea = document.createElement("textarea");
    textArea.value = texto;
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand("copy");
    } catch (err) {
      copiou = false;
      console.error("Falha ao copiar texto: ", err);
    }
    document.body.removeChild(textArea);
  }

  if (setSnackbar) {
    setSnackbar(
      copiou
        ? { children: mensagem, severity: "info" }
        : { children: "Não foi possível copiar", severity: "error" },
    );
  }

  return copiou;
}

export default copyTexto;
export { copyTexto };
